// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import userActions from '../../../actions/userActions';
import configActions from '../../../actions/configActions';
import vehicleActions from '../../../actions/vehicleActions';
import zoneActions from '../../../actions/zoneActions';
import alertActions from '../../../actions/alertActions';
import carActions from '../../../actions/carActions';
import { usersEntitiesSelector } from '../../../selectors/usersSelectors';
import { vehicleEntitiesSelector } from '../../../selectors/vehicleSelectors';
import { convertFromZoneData } from '../../../utils/zoneUtils';
import Sync from '../Sync';
import type { Props } from '../Sync';

const mapStateToProps = (state: State) => {
    return {
        userEntities: usersEntitiesSelector(state),
        vehicleEntities: vehicleEntitiesSelector(state)
    };
};

const mapDispatchToProps = {
    fetchUsers: userActions.fetchUsers,
    loadConfig: configActions.loadConfig,
    setConfig: configActions.setConfig,
    unsetConfig: configActions.unsetConfig,
    loadVehicles: vehicleActions.loadVehicles,
    setVehicle: vehicleActions.setVehicle,
    unsetVehicle: vehicleActions.unsetVehicle,
    loadZones: (data) => zoneActions.loadZones(data.map(zone => convertFromZoneData(zone))),
    setZone: (data) => zoneActions.setZone(convertFromZoneData(data)),
    unsetZone: zoneActions.unsetZone,
    loadAlerts: alertActions.loadAlerts,
    setAlert: alertActions.setAlert,
    unsetAlert: alertActions.unsetAlert,
    unsetCar: carActions.unsetCar
};

export default connect<Props, _, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Sync);